// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require("jquery")
require("flatpickr")


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

//import "../custom/form-validation.js"
//random text
//
import "@claviska/jquery-minicolors/jquery.minicolors"
import "../packs/hello_vue.js"
import "../ck-editor-5/ckeditor.js"
import "../custom/click-listener.js"
import "../custom/test.js"
import "../custom/pdf.js"